import React, { useState, useContext} from "react";
import { StyleSheet, Image, TouchableOpacity, ScrollView, Alert, TextInput, Keyboard, View, Platform } from "react-native";
import * as Yup from "yup";
import configurationPost from "../config/configurationPost";
import * as ImageManipulator from "expo-image-manipulator";
import { MaterialCommunityIcons, AntDesign } from "@expo/vector-icons";

import Screen from "../components/Screen";
import {
  ErrorMessage,
  Form,
  FormField,
  SubmitButton,
} from "../components/forms";
// import authApi from "../api/auth";
//import useAuth from "../auth/useAuth";
import * as ImagePicker from "expo-image-picker"
import connectionConfig from "../config/settings";
import dateNow from "../utility/dateNow";
import UploadScreen from "./UploadScreen";
// import settingStorage from "../config/settingStorage";
// import AsyncStorage from "@react-native-async-storage/async-storage";
import routes from "../navigation/routes";
import colors from "../config/colors";
import defaultStyles from "../config/styles";
import VideoVisor from "../components/VideoVisor";
//import ClipboardText from "../components/ClipboardText";
import * as DocumentPicker from 'expo-document-picker'
import { useEffect } from "react/cjs/react.development";
import createNotification from "../utility/createNotification";
import AuthContext from "../auth/context";



var date = dateNow()

const validationSchema = Yup.object().shape({
  seedName: Yup.string().required().max(100).label("Título de la semilla"),
  seedDescription: Yup.string().required().max(500).label("Descripción de la semilla"),
});

function AddSeedScreen(props) {

  var nameDateDoc = ''
  var nameDateImageAndVideo = ''
  var typeFile = ''
  var typeFileImageAndVideo = ''

  useEffect(() => {
    date = dateNow()
         }, [])

  //const {user} = useAuth();
  const {user, setUser} = useContext(AuthContext);
  const [progress, setProgress] = useState(0);
  const [imageUri, setImageUri] = useState('');
  const [uploadVisible, setUploadVisible] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const [youtubeLink, setYoutubeLink] = useState('');
  const [videoNumber, setVideoNumber] = useState('');
  const [pickerFile, setPickerFile] = useState(null);

  var type = 0 //es el identificador para semilla


  const handleSubmit = async (listing, { resetForm }) => {
    //debugger
    resetForm()
    //Valida el tipo de archivo que se eligio 
    if (pickerFile != null) {
      if (pickerFile.name.includes('.pdf')) {
        typeFile = 'application/pdf'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.pdf'
      }
      if (pickerFile.name.includes('.avi')) {
        typeFile = 'video/x-msvideo'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.avi'
      }
      if (pickerFile.name.includes('.mp4')) {
        typeFile = 'application/mp4'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
      }
      if (pickerFile.name.includes('.mov')) {
        typeFile = 'video/quicktime'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
      }
      if (pickerFile.name.includes('.jpg')) {
        typeFile = 'image/jpeg'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
      }
      if (pickerFile.name.includes('.png')) {
        typeFile = 'image/png'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.png'
      }
      if (pickerFile.name.includes('.xls')) {
        typeFile = 'application/vnd.ms-excel'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.xls'
      }
      if (pickerFile.name.includes('.xlxs')) {
        typeFile = 'application/xlxs'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.xlxs'
      } 
    }
    //Valida si es imagen o video lo que se eligio
    if (imageUri != '') {
      if (imageUri.includes('.jpg')) {
        typeFileImageAndVideo = 'image/jpeg'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
      }
      if (imageUri.includes('.mp4')) {
        typeFileImageAndVideo = 'application/mp4'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
      }
      if (imageUri.includes('.mov')) {
        typeFileImageAndVideo = 'video/quicktime'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
      }
    }

    var post_values = {
        seedName         : listing.seedName, 
        seedDescription  : listing.seedDescription, 
        seedPhoto        : nameDateImageAndVideo,
        userId           : JSON.parse(user).userId,
        createDateSeed   : date,
        type             : type,
        documentSeed     : nameDateDoc
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/insertSeed/', configurationPost)
      .then(response => response.json())
      .then(response => {
        setProgress(1);
        setUploadVisible(true)
        if (imageUri != '') {
            savePhoto()

        }
        if (pickerFile != null) {
          saveMultiple()
        }
      var  descripNotification = JSON.parse(user).userName + ' creó una nueva semilla'  
      var  seedId = response.data.insertId 
      var  userId = JSON.parse(user).userId 
      var  notificationTypeId = 1
      var  CompOrigin = 'AddSeed'
        createNotification.insertNotification(descripNotification,seedId, userId, notificationTypeId, CompOrigin)
        props.navigation.navigate(routes.NO_BOTTON )
      })
      .catch(err =>{
        console.log('update fixo failed :( review internet service /insertSeed/', err )
      })

  };

//--------------------------------------------- 
//Rutina para guardar una foto o video
//---------------------------------------------
const savePhoto = async () => {
  let format = 'JPEG'
  let quality = 0.1

  
 if (Platform.OS === 'android') {
    quality = 0.5
  
} else {
    quality = 0.05
}

  //debugger
  try {
    const formData = new FormData()
    if (typeFileImageAndVideo === 'image/jpeg') {
      const manipResult = await ImageManipulator.manipulateAsync(
        imageUri,
        [],
        { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
      formData.append('photoAndVideo', {
        uri: manipResult.uri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'application/mp4') {
      formData.append('photoAndVideo', {
        uri: imageUri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'video/quicktime') {
      formData.append('photoAndVideo', {
        uri: imageUri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    const configurationPost = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      body: formData
    }
    // post Para guardar imagen de perfil
    fetch(connectionConfig.apiUrl + '/upload_infoPhotoAndVideo', configurationPost)
      .then(response => response.json())
      .then(response => {
        //debugger
        setProgress(1)
        setImageUri('')
        typeFileImageAndVideo = ''
        nameDateImageAndVideo = ''
        
        if (response.data === 'descarga-> error') {
          console.log("maintennance server descarga-> error /upload_infoPhotoAndVideo")
        }
      })
      .catch((err) => {
        alert("Entre en el penultimo catch de addseed", err)
        setProgress(1)
        console.log("maintennance server -> catch /upload_infoPhotoAndVideo", err)
      })
  } catch (error) {
    alert("Entre en último catch de addseed", err)
    setProgress(1)
    console.log("maintennance server -> catch Final /upload_infoPhotoAndVideo", error)
  }
}

//--------------------------------------------------
//  Select Image es la función que te permite sacar
//  la biblioteca de imagenes de tu Cel 
//--------------------------------------------------
  const selectImage = async () => {
      try {
        const result = await ImagePicker.launchImageLibraryAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.All,
          allowsEditing: true,
          aspect: [4, 3],
          //quality: 0,
        })
        if(!result.cancelled)
        setImageUri(result.uri)
      } catch (error) {
         console.log("error al leer imagen", error) 
      }
  }

  
//--------------------------------------------------
// Función para extraer el Id del link de Youtube
//--------------------------------------------------
  const onChangeText = async (text) => {
     setYoutubeLink(text)
    console.log(youtubeLink)
        try {
          let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
          const id = youtubeLink.match(re)[7];
          setVideoNumber(id)
          console.log(videoNumber)
        } catch (error) {
          console.log("error en el link de Youtube", error) 
        }
      
  } 

//---------------------------------------------
//Rutina que guarda el document de la info 
//---------------------------------------------
const saveMultiple = async () => {
  debugger
  try {      
    const formData = new FormData()
    formData.append('multiservice',{
      uri:  pickerFile.uri,
      type: typeFile,
      name: nameDateDoc,
    })
    const configurationPost = {
      method :'POST',
      headers:{
        'Accept': 'application/json',
        'Content-Type':'multipart/form-data'
      },
      body:formData
    }
   // post Para guardar imagen de perfil
    fetch(connectionConfig.apiUrl + '/upload_Documents', configurationPost)
    .then(response => response.json())
    .then(response => {
      //debugger
      setProgress(1)
      setPickerFile(null)
      if(response.data === 'descarga-> error'){
        console.log("maintennance server /upload_Documents descarga-> error")   
      }
    })
    .catch((err) => {
      console.log( "maintennance server -> catch /upload_Documents ", err)   
    })
  } catch (error) {
    console.log( "maintennance server -> catch Final /upload_Documents ", error)   
  }
}

//----------------------------------------------------------------------------
//Servicio para buscar un navegador de archivos del celular para buscar un pdf 
//----------------------------------------------------------------------------
const uploadDocument = async () => {
 var options = {
   type: 'image/png'
 }
 if (Platform.OS === 'android') {

   options = {
   
     copyToCacheDirectory: true,
     multiple: false
   }
 } else {
   options = {
     copyToCacheDirectory : true,
    
     multiple: false
   }
 }
 try {
   if (Platform.OS === 'android') {
     await DocumentPicker.getDocumentAsync(options)
     .then(res => {
      // debugger
      if (res.type === 'cancel') {
       setPickerFile(null);

      } else {
       setPickerFile(res);
      }
       console.log('res : ' + JSON.stringify(res));
       console.log('User cancelled file picker->', res);
       console.log(res.uri, res.type, res.name, res.size)

     })
   } else {
     await DocumentPicker.getDocumentAsync(options)
     .then(res => {
      // debugger
      if (res.type === 'cancel') {
       setPickerFile(null);

      } else {
       setPickerFile(res);
      }
       console.log('res : ' + JSON.stringify(res));
       console.log('User cancelled file picker->', res);
       console.log(res.uri, res.type, res.name, res.size)

     }) 
   }
 } catch (err) {
   setPickerFile(null);
  
     alert('Unknown Error: ' + JSON.stringify(err));
     throw err;
 }
}

  return (

    <Screen style={styles.container}>
        <ScrollView>
            <UploadScreen
                onDone={() => setUploadVisible(false)}
                progress={progress}
                visible={uploadVisible}
            />
            <TouchableOpacity  style={styles.image} onPress = {selectImage}>
                {imageUri != '' ? 
                    <Image style={styles.imagePhoto} source={{uri: imageUri} } />
                :
                    <MaterialCommunityIcons 
                    //style={styles.image}
                    name="camera"
                    size={150}
                    color={colors.medium}            
                    />
                }     
            </TouchableOpacity>

            {pickerFile != null ?                         
                        <MaterialCommunityIcons 
                        //style={styles.image}
                        onPress = {()=> uploadDocument()}
                        name={"file-check-outline"}
                        size={35}
                        color={colors.lemonGreen}
                        style={styles.pdfIcon}         
                        />

                    :
                        <AntDesign 
                        //style={styles.image}
                        onPress = {()=> uploadDocument()}
                        name={"pdffile1"}
                        size={35}
                        color={defaultStyles.colors.medium}
                        style={styles.pdfIcon}         
                        />
                    }    
            
            <Form
                initialValues={{ seedName: "", seedDescription: "" }}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
            >
                <ErrorMessage
                error="Invalid email and/or password."
                visible={loginFailed}
                />
                <FormField
                autoCapitalize="none"
                autoCorrect={false}
                icon="account-edit"
                name="seedName"
                placeholder="Title"
                maxLength={100}
                />
                <FormField
                autoCapitalize="none"
                autoCorrect={false}
                icon="account-edit"
                name="seedDescription"
                placeholder="Description"
                maxLength={3000}
                />
              
                <FormField
                autoCapitalize="none"
                autoCorrect={false}
                icon="youtube"
                name="YouTubeLink"
                placeholder="Pega el link de Youtube aqui y da clic en el botón"
                maxLength={80}
                onChangeText={text => onChangeText(text)}
                numberOfLines={2}
                />
                <SubmitButton title="Save" />
            </Form>
            <View style={styles.containerYoutubeLink}>      
                <MaterialCommunityIcons
                name={"youtube"}
                size={22}
                color={colors.medium}
                style={styles.iconYoutube}
                />
                <TextInput style={styles.input} 
                           onChangeText={text => onChangeText(text)}
                           placeholder={"Pega link de Youtube y da clic en play"}
                           onChange     = {Keyboard.dismiss}
                    >
                </TextInput>
                <MaterialCommunityIcons
                name={"play"}
                size={22}
                color={colors.medium}
                style={styles.icon}
                />
              </View>
                <View style={styles.visorYoutube} >
                <VideoVisor videoNumber={videoNumber} /> 
                </View>
        </ScrollView> 
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  image: {
    width: 200,
    alignSelf: "center",
    alignItems: "center",
    borderRadius: 5,
  },
  imagePhoto: {
    width: 200,
    height: 200,
    alignSelf: "center",
    marginBottom: "4%",
    borderRadius: 5,
  },
  touchable: {
      position: "absolute",
      marginLeft: "57%",//20,
      marginTop: "30%"//110
  },
  containerYoutubeLink: {
    marginTop:"5%",
    flexDirection:"row",
    justifyContent: 'space-evenly',
    backgroundColor: colors.light,
    padding: "2%",
    borderRadius: 30,
  },
  input:{
    borderColor: colors.medium,
    //backgroundColor: colors.light,
    fontSize: 17,
    color: "#202731",
    width:"85%",
},
iconYoutube:{
  alignSelf:"center",
  padding: "2%",
  borderRadius: 11,
  justifyContent: "center",
  alignItems: "center",
  marginRight: "5%",
  marginLeft: "4%",
},
icon:{
    alignSelf:"center",
    margin:10,
    width:"10%",
},
pdfIcon:{
  marginLeft: "10%",
  width:"10%",
},
visorYoutube:{
  width: "90%",
  marginTop: "4%",
  marginLeft: "5%",
}
});

export default AddSeedScreen;